import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();
export const addRegistrationCommentApi = async (
    CourseRegistrationId: string,
    Comment: string,
    url:string
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/RegistrationComment/Create`, {
            CourseRegistrationId,
            Comment
        },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        )
        return response.data;
    } catch (error) {
        console.error('API Error', error);
        throw error
    }
}

export const getRegistrationCommentApi = async ( CourseRegistrationId:string, url:string) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/RegistrationComment/GetByCourseRegistrationId/${CourseRegistrationId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};